// extracted by mini-css-extract-plugin
export default {"headline":"Headline_headline__rHHyo","description":"Headline_description__yA99p","brand":"Headline_brand__8romP","title":"Headline_title__qfWlc"};